module.exports = __webpack_public_path__ + "img/logo_blue.da3aff8e.png";